/* template */
<template><div class="transfer-card" v-if="(trainInfo)"><div class="transfer-card-header" v-if="(hasSelectedSeat)"><div class="transfer-card-header-info"><div class="union-logotype"><mpx-image src="https://ut-static.udache.com/webx/sfc/5jewOiQAoTmZ7i5nVfKvo.png" class="union-logotype-icon"/><span>中转</span></div><div class="transfer-time-info">{{ transferTime }}</div></div><mpx-view @tap="changeShowDetail" class="transfer-card-header-toggle"><span>{{ toggleText }}</span><mpx-image :class="(showDetail && 'rotate')" src="https://ut-static.udache.com/webx/sfc/qjwThjrNdVx-Qd8e8pzmP.png" class="icon"/></mpx-view></div><div class="transfer-card-content"><div :style="[(detailStyle)] | transRpxStyle" class="expand-wrapper"><div class="transfer-card-content-detail"><div v-for="(item, index) in (trainInfo.transfer_ticket)"><train-information-new noDetail isTransfer :cardIndex="(index + 1)" :trainInfo="(item)" @click="showSSI"/><transfer-info-tip :style='["margin: 0 -12px"] | transRpxStyle' :startStation="(item?.to_station_name ?? '')" :toStation="(trainInfo?.transfer_ticket[index + 1]?.from_station_name ?? '')" :stopTime="(trainInfo.transfer_stop_time)" v-if="(index !== trainInfo.transfer_ticket.length - 1)"/></div></div></div><div :style="[(sketchyStyle)] | transRpxStyle" class="expand-wrapper"><div class="transfer-card-content-sketchy"><div v-for="(item, index) in (trainInfo.transfer_ticket)" class="transfer-card-content-sketchy-item"><div class="left"><div class="placeholder"><div class="train-code">{{ transferTrainInfo(item) }}</div></div><div class="station"><span>{{ item.from_station_name }}</span><mpx-image src="https://ut-static.udache.com/webx/sfc/X9HWVKNYaAb2Zu8ZlpcY4.png" class="icon"/><span>{{ item.to_station_name }}</span></div></div><div class="right">{{ getText(item, index) }}</div></div></div></div></div><div class="selected-seat-info">{{ hasSelectedSeatPrice }}</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m074f587b"}'>
  .transfer-card
    display flex
    flex-direction column
    background #fff
    margin 0 -12px
    padding 2px 16px 10px 16px
    &-header
      display flex
      justify-content space-between
      align-items center
      margin-bottom 12px
      &-info
        display flex
        align-items center
      .union-logotype
        padding 3px 6px
        border-radius 4px
        font-family PingFangSC-Medium
        font-size 12px
        font-weight 500
        line-height 12px
        text-align center
        color #FFFFFF
        background #FF6400
        margin-right 8px
        &-icon
          height 11px
          width 11px
          margin-right 2px
      .transfer-time-info
        font-family PingFangSC-Medium
        font-size 14px
        font-weight 500
        line-height 16px
        color #222
      &-toggle
        font-size 14px
        font-weight 400
        line-height 14px
        color #666
        display flex
        align-items center
        .icon
          height 4.5px
          width 8px
          margin-left 3px
          &.rotate
            transform rotate(180deg)
    &-content
      &-sketchy
        min-height 0
        overflow hidden
        display flex
        flex-direction column
        visibility visible
        opacity 1
        transition all 0.3s linear
        &-item
          display flex
          justify-content space-between
          align-items center
          &:not(:last-child)
            margin-bottom 10px
          .left
            display flex
            .placeholder
              min-width 71px
              margin-right 8px
              display flex
              .train-code
                padding 3px 6px
                font-family PingFangSC-Medium
                font-size 12px
                font-weight 500
                line-height 12px
                color #666
                border-radius 4px
                background #F2F6F9
            .station
              display flex
              align-items center
              font-family PingFangSC-Medium
              font-size 16px
              font-weight 500
              line-height 16px
              color #222
              .icon
                height 4px
                width 14px
                margin 0 4px
          .right
            font-size 13px
            font-weight 400
            line-height 13px
            color #666666
      &-detail
        min-height 0
        overflow hidden
  .expand-wrapper
    display grid
    transition grid-template-rows 0.5s 0s, opacity 0.5s 0.1s
    grid-template-columns 100%
    overflow hidden
  .selected-seat-info
    padding-left 14px
    margin-top 10px
    line-height 14px
    font-size 14px
    color #333
    font-family PingFangSC-Medium
    font-weight 500
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m074f587b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./transfer-info-card.mpx.js?isComponent&outputPath=components%2Ftransfer-info-card074f587b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./transfer-info-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftransfer-info-card074f587b%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m074f587b"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/transfer-info-card074f587b/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'transfer-info-tip':getComponent(require("../../../components/transfer-info-tip.mpx?isComponent&outputPath=components%2Ftransfer-info-tip794aa58f%2Findex")),'train-information-new':getComponent(require("../../../components/train-information-new/index.mpx?isComponent&outputPath=components%2Findex7f4255a4%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
